import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Styles from "./Register.module.css";

const StepperList = ({ list, current, handleViewType }) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    setActiveStep(list?.filter((ele) => ele?.value === current)?.[0]?.id - 1);
  }, [current, list]);

  const handleStepClick = (stepIndex) => {
    setActiveStep(stepIndex);
  };
  

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {list?.map((step, index) => (
          <Step key={step?.value}>
            <StepLabel
               onClick={() => {
                if (index < activeStep) {
                  setActiveStep(index);
                  handleViewType(step.value);
                }
              }}
              style={{  cursor: index < activeStep ? "pointer" : "not-allowed",
                opacity: index < activeStep ? 1 : 3, }}
            >
              <div className={Styles.stepsListCont}>
                <div
                  className={
                    activeStep === index
                      ? Styles.activeNameStepper
                      : Styles.inActiveNameStepper
                  }
                  style={{
                    color: activeStep === index ? "#FF8C00" : "#666",
                    fontSize: "16px",
                    fontWeight: activeStep === index ? 600 : 400,
                  }}
                >
                  {step.name}
                </div>
                {activeStep === index && (
                  <div style={{ color: "#FF8C00", fontSize: "14px" }}>
                    In Progress
                  </div>
                )}
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepperList;
